import { useParams } from "react-router-dom";
import Seo from "../../components/Seo";
import { CASE_BODIES } from "../cases/bodies";
import { findCase } from "../data/cases";
import NotFoundPage from "./NotFoundPage";

export default function CaseDetailPage() {
  const { slug } = useParams();
  const c = findCase(slug);
  const Body = CASE_BODIES[slug];
  if (!c || !Body) return <NotFoundPage />;
  return (
    <>
      <Seo
        title={c.title}
        description={`${c.meta}｜${c.title}。LEAPSが手がけた${c.tags.filter((t) => /開発|インテグレーション|制作/.test(t)).join("・") || "プロジェクト"}の実績です。`}
        path={`/cases/${slug}`}
        type="article"
      />
      <Body />
    </>
  );
}
